// Cache tag for the generated learner-courses endpoint, kept out of the generated
// `learnerCourses.ts` so a regenerate cannot drop it (the pattern `cycleCacheTags.ts` follows).
// Import the hook from `learnerCoursesEnhanced.ts`, never from `./learnerCourses`, or the tag is
// missing. Deliberately import-free.
//
export const learnerCourseCacheTags = {
  listMyCourses: {
    providesTags: (result: readonly { course_id: string }[] | undefined) =>
      result
        ? [
            ...result.map(({ course_id }) => ({ type: 'LearnerCourses' as const, id: course_id })),
            { type: 'LearnerCourses' as const, id: 'LIST' }
          ]
        : [{ type: 'LearnerCourses' as const, id: 'LIST' }]
  },
  startMyCourse: {
    invalidatesTags: () => [{ type: 'LearnerCourses' as const, id: 'LIST' }]
  }
} as const
